import { NavLink } from 'react-router';
import React from 'react';
import {
  carrierStatusFormatter, dateFormatter,
  dateTimeFormatter, inRegistryFormatter, lastTimeFormatter, legalityFormatter, localeFormatter,
  locationFormatter,
  userFIOFormatter, vehicleRegisterStatusFormatter,
} from '../../../utils/formatters';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export const vehicleRegistryColumns = [
  {
    dataField: 'vehicle_lpn',
    headerClassName: 'vehicle-reg-number-column',
    text: 'ГРН ТС',
  },
  {
    dataField: 'registry_vehicle',
    text: 'Номер записи',
    headerClassName: 'status-column',
    formatter: item => <NavLink target="_blank" to={`/region-registry/passenger-taxi?registry_id=${item?.id}`}>{item?.number}</NavLink>,
  },
  {
    dataField: 'vehicle_model',
    text: 'Модель',
    headerClassName: 'status-column',
  },
  {
    dataField: 'vehicle_brand',
    text: 'Бренд',
    headerClassName: 'status-column',
  },
  {
    dataField: 'vehicle_vin',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'vehicle_color',
    headerClassName: 'status-column',
  },
  {
    dataField: 'driver',
    headerClassName: 'driver-name-column',
    text: 'Водитель',
    formatter: item => userFIOFormatter({ last_name: item?.driver_last_name, first_name: item?.driver_first_name, middle_name: item?.driver_middle_name }),
    disableSort: true,
  },
  {
    dataField: 'updated_at',
    text: 'Дата и время события',
    headerClassName: 'start-date-column',
    formatter: dateTimeFormatter,
    defaultSort: true,
  },
  {
    dataField: 'updated_at',
    text: 'Последнее обновление',
    headerClassName: 'start-date-column',
    formatter: lastTimeFormatter,
    disableSort: true,
  },
  {
    dataField: 'vehicle_status',
    text: 'Текущий статус',
    headerClassName: 'status-column',
    formatter: a => vehicleRegisterStatusFormatter(a),
  },
  {
    dataField: 'registry_vehicle',
    text: 'Наличие ТС в реестрах',
    headerClassName: 'status-column',
    formatter: inRegistryFormatter,
    disableSort: true,
  },
  {
    dataField: 'driver',
    text: 'Дата окончания В/У',
    headerClassName: 'status-column',
    formatter: item => (item?.driver_license_valid_until_date ? dateFormatter(item?.driver_license_valid_until_date) : ''),
    disableSort: true,
  },
  {
    dataField: 'last_coordinate',
    text: 'Последние координаты',
    headerClassName: 'status-column',
    formatter: (_, item) => locationFormatter({ latitude: item.last_latitude, longitude: item.last_longitude }),
    disableSort: true,
  },
  {
    dataField: 'last_speed',
    text: 'Скорость, км/ч',
    headerClassName: 'status-column',
  },
  {
    dataField: 'total_travel_time',
    text: 'Общее время в пути',
    headerClassName: 'status-column',
  },
  {
    dataField: 'registry_vehicle',
    text: 'ecology_class_short',
    headerClassName: 'procedure-name-column',
    formatter: item => localeFormatter('ecology-class', item?.ecology_class),
    disableSort: true,
  },
  {
    dataField: 'is_illegal',
    text: 'Легальность',
    headerClassName: 'procedure-name-column',
    formatter: legalityFormatter,
    disableSort: true,
  },
];

export const vehicleMapSearchColumns = [
  {
    dataField: 'vehicle_lpn',
    headerClassName: 'vehicle-reg-number-column',
    text: 'ГРН ТС',
  },
  {
    dataField: 'vehicle_model',
    text: 'Модель',
    headerClassName: 'model-column',
  },
  {
    dataField: 'vehicle_brand',
    text: 'Бренд',
    headerClassName: 'brand-column',
  },
  {
    dataField: 'registry_vehicle',
    text: 'Номер записи',
    headerClassName: 'status-column',
    formatter: item => <NavLink target="_blank" to={`/region-registry/passenger-taxi?registry_id=${item?.id}`}>{item?.number}</NavLink>,
  },
];
